import { blogWkGateway } from '@/request';

import { blogPostsRequest, blogPostsResponse } from './interface/news';

export const getBlogPosts = (params: blogPostsRequest) => {
  return blogWkGateway.get<blogPostsResponse, blogPostsResponse>(
    `/blog/wp-json/wp/v2/blog-posts?page=${params.page}&per_page=${params.per_page}&category=${params.category}`,
  );
};
